// Components
import { IDaysOfWeekOption } from "./Helpers";
import { IDynamicQuery, IQueryArguments, IFilterOption } from "@vmosolutions/oc-interfaces";

// UNBOOKED FLIGHT SEARCH FILTERS
export const unbookedFilterOptions: IFilterOption[] = [
  {
    value: "outTime",
    label: "Departure Date",
    type: "unbookedFlights",
    searchValue: null,
  },
  {
    value: "inTime",
    label: "Arrival Date",
    type: "unbookedFlights",
    searchValue: null,
  },
  {
    value: "airlineIATA",
    label: "Airline Code",
    type: "unbookedFlights",
    searchValue: null,
  },
  {
    value: "flightNumber",
    label: "Includes Flight #",
    type: "unbookedFlights",
    searchValue: null,
  },
  {
    value: "onCrewMember",
    label: "Crew Member",
    type: "unbookedFlights",
    searchValue: null,
  },
  {
    value: "shortId",
    label: "Short Code",
    type: "unbookedFlights",
    searchValue: null,
  },
  {
    value: "origin",
    label: "Origin",
    type: "unbookedFlights",
    searchValue: null,
  },
  {
    value: "destination",
    label: "Destination",
    type: "unbookedFlights",
    searchValue: null,
  },
];

/**
 * for content management
 * Parse the current search filter format into the accepted query format
 */
export const convertFilter2Query = (searchFilter: any): IDynamicQuery => {
  //input (Filter Search format) = { value: "f_flightNumber", label: "Flight #", type: "flightEvent", searchValue: ["908", "112"]}
  //output (IDynamicQuery format) = { field: "flightNumber", condition: "EQ", value: [908, 112] };

  // Filters are reduced so that they are only returned if they contain valid values.
  const newFilters = searchFilter.reduce((queryFilters: IQueryArguments[], filter: any) => {
    const fieldName = filter.value;
    if (!filter.searchValue) {
      return null;
    }
    const { searchValue } = filter;
    const queryObjs: IQueryArguments[] = [];

    switch (fieldName) {
      // Unbooked flight departure/arrival
      case "outTime":
      case "inTime": {
        const timeFieldName = fieldName === "outTime" ? "positioningFlight.outTime" : "positioningFlight.inTime";
        const from = searchValue?.minTime ? new Date(searchValue.minTime)?.valueOf() : null;
        const to = searchValue?.maxTime ? new Date(searchValue.maxTime)?.valueOf() : null;
        const timeQueryObj: IQueryArguments = { field: timeFieldName, condition: "EQ", value: null };
        if (!!from && !!to) {
          timeQueryObj.condition = "BT";
          timeQueryObj.value = [from, to];
        } else if (!!from && !to) {
          timeQueryObj.condition = "GT";
          timeQueryObj.value = from;
        } else {
          timeQueryObj.condition = "LT";
          timeQueryObj.value = to;
        }
        // If supplied, apply selected days in it's rrule format.
        const byDays = filter?.searchValue?.daysOfWeek;
        const rRule: string =
          Array.isArray(byDays) && byDays.length > 0
            ? `BYDAY=${byDays.map((option: IDaysOfWeekOption) => option.rrule).toString()};`
            : null;
        if (rRule) {
          timeQueryObj.rrule = rRule;
        }
        queryObjs.push(timeQueryObj);
        break;
      }
      case "airlineIATA":
        queryObjs.push({ value: searchValue, condition: "EQ", field: "positioningFlight.airlineIATA" });
        break;
      case "flightNumber":
        queryObjs.push({
          value: searchValue.map((flightNumber: string) => parseInt(flightNumber)),
          condition: "EQ",
          field: "positioningFlight.flightNumber",
        });
        break;
      case "onCrewMember":
        queryObjs.push({
          field: "positions.crew",
          condition: "EQ",
          value: searchValue,
        });
        break;
      case "shortId":
        queryObjs.push({ value: searchValue, condition: "EQ", field: "pairing_shortId" });
        break;
      case "origin":
      case "destination": {
        const fieldValue = fieldName === "origin" ? "positioningFlight.origin" : "positioningFlight.destination";
        queryObjs.push({ value: searchValue, condition: "EQ", field: fieldValue });
        break;
      }
      // default:
    }

    queryFilters.push(...queryObjs);

    return queryFilters;
  }, []);
  return {
    queryArgs: newFilters,
    returnFields: [],
  };
};
